import React from 'react';
import { Button } from 'react-bootstrap';
import MainLogo from "../../../../images/main-logo.svg"
import SuccessIcon from "../../../../images/success-new.png"
import "./Success.scss"
import { useNavigate } from 'react-router-dom';

function Success() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    const legacyContact = localStorage.getItem("legacyContact") === "true";

    if (legacyContact) {
      navigate("/my-gifts");
    } else {
      navigate("/legacy-contact");
    }
  };

  return (
    <>
      <section className='success-screen'>
        <div className='success-screen-block'>
          <div className='success-screen-in'>
            <span>
              <figure>
                <img src={MainLogo} alt='Background' />
              </figure>
              <p style={{color:'#677289', fontWeight:700, fontSize:"20px"}}>
                We've successfully processed your payment.
              </p>
              <figure className='success-icon'>
                <img src={SuccessIcon} alt='' />
              </figure>
              <p style={{fontSize:"20px"}}>
                You can now begin choosing gifts for your loved ones.
              </p>
              <Button className="main-bttn" onClick={handleGetStarted}>
                Get Started
              </Button>
            </span>
          </div>
        </div>
      </section>
    </>
  );
}

export default Success;
